import { useSearchParams } from "react-router-dom";
import { Logo } from "../components/Logo";

export default function LoginPage() {
  const [params] = useSearchParams();
  const next = params.get("next") ?? "/";
  const sessionExpired = params.get("session") === "expired";
  const startUrl = `/api/auth/google/start?next=${encodeURIComponent(next)}`;

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="card max-w-sm w-full p-6 text-center space-y-4">
        <div className="flex justify-center">
          <Logo className="w-12 h-12 text-brand-600" />
        </div>
        <h1 className="text-xl font-bold text-slate-800">Jedalniček</h1>
        {sessionExpired && (
          <p className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-3 py-2">
            Vaše přihlášení vypršelo. Přihlaste se prosím znovu.
          </p>
        )}
        <a href={startUrl} className="btn-primary w-full justify-center">
          Přihlásit se přes Google
        </a>
      </div>
    </div>
  );
}
